module.exports = __webpack_public_path__ + "static/authorities-screenshot-85e972445dbde0a2d045b6116ced1d78.png";